import { render, staticRenderFns } from "./history-sinister-affiliate.vue?vue&type=template&id=3224213c"
import script from "./history-sinister-affiliate.vue?vue&type=script&lang=js"
export * from "./history-sinister-affiliate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports